import { render, staticRenderFns } from "./quote-box.vue?vue&type=template&id=797c1d14&scoped=true"
import script from "./quote-box.vue?vue&type=script&lang=js"
export * from "./quote-box.vue?vue&type=script&lang=js"
import style0 from "./quote-box.vue?vue&type=style&index=0&id=797c1d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c1d14",
  null
  
)

export default component.exports